import { LocalStorage } from "@/lib/__shared__/localStorage";

export interface ILocalRepository {
	lastPlayedTrack: {
		// not currently used, just keeping this to reference the pattern for future local storage needs
		set: (trackId: string) => Promise<void>;
		get: () => Promise<string | null>;
	};
}

const LAST_PLAYED_TRACK_KEY = "LAST_PLAYED_TRACK";

export const LocalRepository: ILocalRepository = {
	lastPlayedTrack: {
		set: async (trackSlug: string): Promise<void> => {
			await LocalStorage.set(LAST_PLAYED_TRACK_KEY, trackSlug);
		},
		get: async (): Promise<string | null> => {
			return await LocalStorage.get(LAST_PLAYED_TRACK_KEY);
		},
	},
};
